/**
 * Authentication Debugging Utility
 *
 * Use this in the browser console to debug authentication issues:
 *
 * import { debugAuth } from './utils/auth-debug';
 * debugAuth();
 *
 * Or expose it globally:
 * (window as any).debugAuth = debugAuth;
 */

/* eslint-disable no-console */

import { axios, getTokenReadyStatus, isAxiosAuthorized } from "./axios.create";

export const debugAuth = () => {
  console.group("🔍 Authentication Debug Info");

  // Check axios configuration
  console.log("📋 Axios Configuration:", {
    baseURL: axios.defaults.baseURL,
    hasAuthHeader: !!axios.defaults.headers.common["Authorization"],
    authHeaderPreview: axios.defaults.headers.common["Authorization"]
      ? `${String(axios.defaults.headers.common["Authorization"]).substring(0, 30)}...`
      : "MISSING",
    contentType: axios.defaults.headers.common["Content-Type"],
    isTokenReady: getTokenReadyStatus(),
    isAuthorized: isAxiosAuthorized(),
  });

  // Check localStorage for Auth0 data
  console.log("💾 LocalStorage Auth Data:");
  const authKeys = Object.keys(localStorage).filter(
    (key) =>
      key.includes("auth0") || key.includes("token") || key.includes("@@auth"),
  );
  authKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    console.log(
      `  - ${key}: ${value ? `${value.substring(0, 50)}...` : "null"}`,
    );
  });

  // Check environment variables
  console.log("⚙️ Environment:", {
    backendURL: process.env.REACT_APP_BACKEND_URL,
    accountId: process.env.REACT_APP_ACCOUNT_ID,
    auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
    auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    auth0Organization: process.env.REACT_APP_AUTH0_ORGANIZATION,
  });

  // Test a simple request
  console.log("📡 Testing API Connection...");
  axios
    .get("/test-connection")
    .then((response) => {
      console.log("✅ API Connection Test:", response.status);
    })
    .catch((error) => {
      console.error("❌ API Connection Test Failed:", {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        sentAuth: error.config?.headers?.Authorization ? "YES" : "NO",
      });
    });

  console.groupEnd();
};

// Expose globally for easy access in console
if (typeof window !== "undefined") {
  (window as any).debugAuth = debugAuth;
}
